// tab
jQuery(function($) {
  if ($('#js-on-off').length) {
    // 変数
    var $target = $('#js-on-off');
    var $trigger = $target.find('.s-on-off-tab__trigger');
    var $content = $target.find('.s-on-off-tab__content');
    var $btn = $target.find('.js-on-off-trigger-btn');
    // クリックイベント
    $trigger.on('click', function () {
      var $tabNav = $(this).parent('.s-on-off-tab__nav');
      var $tab = $tabNav.parents('#js-on-off');
      var $tabBody = $tab.find('.s-on-off-tab__body');
      var $tabCont = $tabBody.find('.s-on-off-tab__content');
      var _index = $tabNav.find('.s-on-off-tab__trigger').index(this);
      $tabNav.find('.s-on-off-tab__trigger').removeClass('is-current');
      $(this).addClass('is-current');
      $tabCont.removeClass('is-current');
      $tabCont.eq(_index).addClass('is-current');
    });
    $btn.on('click', function () {
      var _position = $target.offset().top;
      var _index = $target.find('.s-on-off-tab__trigger.is-current').index();
      $trigger.addClass('is-current');
      $trigger.eq(_index).removeClass('is-current');
      $content.addClass('is-current');
      $content.eq(_index).removeClass('is-current');
      $('html, body').animate({
        scrollTop: _position - 80 + 'px'
      }, 800, 'swing');
    });
  }
});
